module.exports = __webpack_public_path__ + "static/media/connectIPS-logo.01b087a3.jpg";